export default "__VITE_ASSET__DyHX2QBn__"